import { Font, StyleSheet } from "@react-pdf/renderer";
import { Page, Text, View, Document, Image } from "@react-pdf/renderer";
import { handleArabicPunctuation } from "../../function";

Font.registerHyphenationCallback((word) => [word]);

Font.register({
  family: "IBM Plex Sans Arabic",
  src: "/fonts/IBMPlexSansArabic/IBMPlexSansArabic-Regular.ttf",
});
Font.register({
  family: "IBM Plex Sans Arabic Bold",
  src: "/fonts/IBMPlexSansArabic/IBMPlexSansArabic-Bold.ttf",
});

export const Styles = StyleSheet.create({
  portraitPage: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: "9px",
    lineHeight: "1.7",
    padding: "57px 17px",
    flexDirection: "row",
  },
  landscapePage: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: "9px",
    padding: "57px 17px",
    flexDirection: "row",
    lineHeight: "1.7",
  },

  arrowIconCont: {
    width: "40px",
    fontSize: "6px",
    alignItems: "flex-start",
  },
  arrowIcon: {
    width: "12px",
    height: "7px",
  },
  curveArrowIcon: {
    width: "12px",
    height: "15px",
  },
  pointingText: {
    marginBottom: "6px",
    fontFamily: "IBM Plex Sans Arabic Bold",
  },
  flexRowReverse: {
    flexDirection: "row-reverse",
  },
  flexWrap: {
    flexWrap: "nowrap",
  },
  ml1: {
    marginLeft: "2pt",
  },
});

const MyDocument1 = (props) => {
  let { arabChunks, engChunks } = props;
  const arabicText = (arabicChunks) => {
    return (
      // iterate over the text divided in lines
      arabicChunks?.map((line, idx) => {
        return (
          <View style={[Styles.flexRowReverse, Styles.flexWrap, {}]} key={idx}>
            {
              // divide every line into words and arrange them RTL
              line.map((word, idxWord) => {
                // correct every word for paired punctuation
                return handleArabicPunctuation(word).map(
                  (punctuationWord, punctuationIdx) => {
                    return (
                      <Text style={Styles.ml1} key={punctuationIdx}>
                        {punctuationWord}
                      </Text>
                    );
                  }
                );
              })
            }
          </View>
        );
      })
    );
  };
  let landscapePagesArray = [];
  const landscapePages = () => {
    let k = 0,
      m = 1;
    for (let i = 1; i < 4; i++) {
      landscapePagesArray.push(
        <>
          <View
            style={{
              width: "100%",
              flexDirection: "row",
              paddingRight: "17px",
            }}
          >
            <View style={Styles.arrowIconCont}>
              <View></View>
            </View>
            <View style={{ width: "100%" }}>
              <View
                style={[
                  {
                    height: "225px",
                    textAlign: "right",
                    marginBottom: "30px",
                  },
                ]}
              >
                {arabicText(arabChunks[i + m])}
              </View>
              <View
                style={{
                  height: "225px",
                }}
              >
                {engChunks[i + m]?.map((word, idx) => {
                  return (
                    <Text style={{}} key={idx}>
                      {word}
                    </Text>
                  );
                })}
              </View>
            </View>
            <View style={[Styles.arrowIconCont, { marginLeft: "6px" }]}>
              <View>
                <Image
                  src="/images/leftpdf_arrow.png"
                  style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
                ></Image>
              </View>
              <View style={{ position: "absolute", top: "53%" }}>
                <Image
                  src="/images/leftpdf_arrow.png"
                  style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
                ></Image>
              </View>
            </View>
          </View>
          <View
            style={{
              textAlign: "left",
              width: "100%",
              flexDirection: "row",
              paddingLeft: "17px",
            }}
          >
            <View style={Styles.arrowIconCont}>
              <View></View>
            </View>
            <View style={{ width: "100%" }}>
              <View
                style={[
                  {
                    height: "222px",
                    width: "298px",
                    textAlign: "right",
                    marginBottom: "30px",
                  },
                ]}
              >
                {arabicText(arabChunks[i + k])}
              </View>
              <View style={{ height: "222px", width: "298px" }}>
                {engChunks[i + k]?.map((word, idx) => {
                  return (
                    <Text style={{}} key={idx}>
                      {word}
                    </Text>
                  );
                })}
              </View>
            </View>
            <View style={[Styles.arrowIconCont, { marginLeft: "6px" }]}>
              <View>
                <Image
                  src="/images/leftpdf_arrow.png"
                  style={Styles.arrowIcon}
                ></Image>
              </View>
              <View style={{ position: "absolute", top: "51%" }}>
                <Image
                  src="/images/leftcurvepdf_arrow.png"
                  style={Styles.curveArrowIcon}
                ></Image>
              </View>
            </View>
          </View>
        </>
      );
      m = m + 1;
      k = k + 1;
    }
  };
  landscapePages();

  return (
    <Document>
      <Page size="A5" style={Styles.portraitPage}>
        <View
          style={{ width: "40px", marginRight: "6px", alignItems: "flex-end" }}
        >
          <View
            style={{
              fontSize: "6px",
              color: "#FF0000",
              position: "absolute",
              top: "49.5%",
            }}
          >
            <Text
              style={[
                Styles.pointingText,
                { textAlign: "right", width: "50px" },
              ]}
            >
              Start of text
            </Text>
            <Image
              src="/images/rightpdf_arrow.png"
              style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
            ></Image>
          </View>
        </View>
        <View
          style={{
            width: "100%",
          }}
        >
          <View
            style={[
              {
                height: "225px",
              },
            ]}
          >
            {arabicText(arabChunks[0])}
          </View>
          <View style={{ height: "30px" }}></View>
          <View
            style={{
              height: "225px",
            }}
          >
            {engChunks[0]?.map((word, idx) => {
              return (
                <Text style={{}} key={idx}>
                  {word}
                </Text>
              );
            })}
          </View>
        </View>
        <View style={{ width: "40px", marginLeft: "6px" }}>
          <View
            style={{
              fontSize: "6px",
              color: "#FF0000",
              marginTop: "-13px",
            }}
          >
            <Text style={Styles.pointingText}>بداية النص</Text>
            <Image
              src="/images/leftpdf_arrow.png"
              style={[Styles.arrowIcon]}
            ></Image>
          </View>
        </View>
      </Page>
      {landscapePagesArray.map((array, index) => {
        return (
          <Page
            size="A4"
            style={Styles.landscapePage}
            orientation="landscape"
            key={index}
          >
            {array}
          </Page>
        );
      })}
      <Page size="A5" style={Styles.portraitPage}>
        <View style={{ width: "40px", marginRight: "6px" }}>
          <View
            style={{
              fontSize: "6px",
              color: "#FF0000",
              position: "absolute",
              top: "39%",
            }}
          >
            <Text style={Styles.pointingText}>نهاية النص</Text>
            <Image
              src="/images/rightpdf_arrow.png"
              style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
            ></Image>
          </View>
        </View>
        <View style={{ width: "100%" }}>
          <View
            style={[
              {
                height: "225px",
              },
            ]}
          >
            {arabicText(arabChunks[7])}
          </View>

          <View
            style={{
              height: "225px",
              marginTop: "30px",
            }}
          >
            {engChunks[7]?.map((word, idx) => {
              return (
                <Text style={{}} key={idx}>
                  {word}
                </Text>
              );
            })}
          </View>
        </View>
        <View style={{ width: "40px", marginLeft: "6px" }}>
          <View>
            <Image
              src="/images/leftpdf_arrow.png"
              style={[Styles.arrowIcon, {}]}
            ></Image>
          </View>
          <View style={{ position: "absolute", top: "53%" }}>
            <Image
              src="/images/leftpdf_arrow.png"
              style={[Styles.arrowIcon, {}]}
            ></Image>
          </View>
          <View
            style={{
              fontSize: "6px",
              color: "#FF0000",
              position: "absolute",
              top: "92%",
            }}
          >
            <Text style={Styles.pointingText}>End of text</Text>
            <Image
              src="/images/leftpdf_arrow.png"
              style={Styles.arrowIcon}
            ></Image>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default MyDocument1;
